// src/pages/Blog.js

import React, {useEffect, useState} from 'react';
import {useTrail, useSpring, animated} from 'react-spring';
import { Helmet } from 'react-helmet-async';

import Nav from './components/Base__components/Nav';
import ArticleBox from './components/Articles__components/ArticleBox';
import httpClient from '../Admin/components/httpClient';

import _Functions from './scripts/_Functions';

export default function Blog ({searchParam}) {

    // Page vars
    const perPage = 6;
    const [posts, setPostData] = useState([]);
    const [noPosts, setNoPosts] = useState(true);
    const [page, setPage] = useState(1);
    const [pages, setPageCount] = useState(1);

    // Init animations
    const postTrail = useTrail(posts.length, {
        from: {
            opacity: 0,
            transform: 'translateY(-10%)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    })
    const elFade = useSpring({
        loop: false,
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        },

        config: {
            duration: 300
        }
    })

    // Pagination click
    const handlePaginationClick = (type, num = null) => {
        if (num) setPage(num);
        else setPage(type==='prev' ? (parseInt(page)-1) : (parseInt(page)+1));

        setPostData([]);
        setNoPosts(true);
    }

    // Page load
    useEffect(() => {
        window.addEventListener('mousemove', _Functions.followCursor);

        // Data
        if (noPosts===true) httpClient({
            method: 'get',
            url: '/front/posts/',
            params: {perPage: perPage, page: page, q: searchParam}
        }).then((res) => {
            setPage(res.data.page);
            setPageCount(res.data.pages);
            return res.data.posts;
        }).then((articles) => {
            setPostData(articles);
            setNoPosts(false);
        }).catch(error => {
            setPostData([]);
            setNoPosts(true);
        })

        return () => {
            window.removeEventListener('mousemove', _Functions.followCursor);
        }
    }, [page, searchParam, posts, noPosts])

    return (
        <>
            <Helmet>
                <title>Jan Dočekal - Posts</title>
                <meta name="description"        content="Posts about tech && non-tech, written by Jan Dočekal, a full-stack developer from Prague, CZ." />
                <meta name="keywords"           content="blog, jan docekal, jan dočekal, full-stack, developer, devblog, react, javascript, php, fullstack, webdev" />
                <meta property="og:title"       content="Jan Dočekal - Posts" />
                <meta property="og:description" content="Posts about tech && non-tech, written by Jan Dočekal, a full-stack developer from Prague, CZ." />
            </Helmet>

            <Nav/>
            <div id="cursorPointer" className="font-code"></div>
            <main className="jdckl blog mt-10">
                <section className="text-gray-300 flex items-center font-code mt-10 mb-20">
                    <div className="container flex flex-col items-start mx-auto relative px-6 sm:px-0 lg:px-20">

                        <animated.div style={elFade}>
                            <h2 className="font-display text-4xl md:text-6xl z-10 font-extrabold tracking-wide"><span className="text-highlight">\</span>Posts{searchParam ? <><span className="text-highlight">\</span>{searchParam}</> : ''}</h2>
                        </animated.div>

                            <div className="grid grid-cols-1 gap-6 mt-4 w-full">
                                {
                                posts.length > 0 ? 
                                    postTrail.map((prop, index) => 
                                        <animated.div key={posts[index]._id} style={prop}>
                                            <ArticleBox data={posts[index]} fullSize={true} />
                                        </animated.div>
                                    ) : <></>
                                }
                            </div>
                    </div>
                </section>

                <section className="text-gray-300 flex items-center font-code mt-10 mb-20">
                    <div className="container flex flex-row justify-center mx-auto relative px-6 sm:px-0 lg:px-20">
                        <button onClick={() => handlePaginationClick('prev')} disabled={page<=1 ? "hidden" : ""} className={(page<=1 || noPosts) ? "hidden" : "bg-indigo-700 py-2 px-4 text-sm rounded-md shadow-md mt-4"}>Newer posts</button>
                        <button onClick={() => handlePaginationClick('next')} disabled={page>=pages ? "hidden" : ""} className={(page>=pages || noPosts) ? "hidden" : "bg-indigo-700 py-2 px-4 text-sm rounded-md shadow-md mt-4"}>Older posts</button>
                    </div>
                </section>
            </main>
        </>
    );
}